import { motion } from "framer-motion";
import { BookOpen, ArrowRight } from "lucide-react";

const HomeInsightsFeature = () => {
  return (
    <section className="bg-background py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-6">
        <motion.a
          href="/insights"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="group block rounded-[var(--radius)] border border-border bg-card/60 hover:bg-card hover:border-primary/40 transition-all p-5 md:p-10"
        >
          <div className="grid md:grid-cols-[auto_1fr_auto] gap-4 md:gap-8 md:items-center">
            <div className="flex items-center gap-3 md:block">
              <div className="w-11 h-11 md:w-14 md:h-14 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                <BookOpen className="h-5 w-5 md:h-6 md:w-6 text-primary" />
              </div>
              <div className="md:hidden text-primary text-xs font-semibold tracking-[0.2em] uppercase">
                Research & Insights
              </div>
            </div>
            <div className="min-w-0">
              <div className="hidden md:block text-primary text-xs font-semibold tracking-[0.2em] uppercase mb-2">
                Research & Insights
              </div>
              <h2 className="font-display text-xl md:text-3xl font-bold text-foreground leading-tight mb-2">
                County data, policy briefs, and the stories behind the numbers
              </h2>
              <p className="text-muted-foreground text-sm md:text-base max-w-2xl">
                Long-form analysis on Alabama's emerging market — from priority zip codes to the unbanked gap.
              </p>
            </div>
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary shrink-0">
              Read insights
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </div>
        </motion.a>
      </div>
    </section>
  );
};

export default HomeInsightsFeature;